import React from "react";
import FavoriteMatch from "./FavoriteMatch";

const FavoriteCard = () => {
  return (
    <div>
      <FavoriteMatch />
    </div>
  );
};

export default FavoriteCard;
